var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('iframe',{staticStyle:{"height":"210px","width":"100%"},attrs:{"src":_vm.src,"frameBorder":"0","scrolling":"no"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }